export const electrodes = [
  {
    code: '',
    description: 'Normal Hydrogen Electrode',
    srp: 0, //Standard reduction potential [eV]
  },
];

/*
- Ag/AgCl (saturated KCl)
- Ag/AgNO3
- SCE (saturated KCl)
- NHE
- SHE
- Hg/HgSO4 (saturated K2SO4)
 */
